import React, {FC} from 'react';
import DatePicker, {DateObject} from 'react-multi-date-picker';
import 'react-responsive-modal/styles.css';
import {useStoreon} from 'storeon/react';
import {
    GxButton, GxCheckbox, GxForm,
    GxIcon, GxInput, GxPhoneInput, GxRadio,
    GxTextarea
} from '@garpix/garpix-web-components-react';
import Select from 'react-select';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import {useFormik} from 'formik';
import cn from 'classnames';
import { State, Events } from '@/interfaces';
import styles from './styles/index.module.scss';
import {PhoneIcon, TaskIcon} from '../../../../assets';
import CalendarInput from '../../../../components/CalendarInput';
import ModalLayout from '../../../../components/ModalLayout';
import {DAYS_WEEK_TASK, MONTH_WEEK_TASK} from '../../../Tasks/const';
import {TYPE_MODAL_TASK} from './const';
import {months, weekDays} from '../../../../const/calendar';
import dayjs from '../../../../utils/dayjs';
import {DAYS_TASK, customStylesSelect, TYPE_REPEAT_TASK} from '../../../CreateTask/const';
import {IModalCreateTask} from '../../interfaces';
import {initialValueCreateTaskCustomer, submitModalCreateTask} from './helpers';
import InputUploadFile from '../../../../components/InputUploadFile';
import MultiSelectGroups from '../../../CreateTask/components/MultiSelectGroups';
import Switcher from '../../../../components/Switcher';
import TypeTaskSelect from '../../../CreateTask/components/TypeTaskSelect';
import {createTaskSchemaStaff, createTaskSchemaSuperAdmin} from '../../schema';
import useModal from '../../../../hooks/useModal';
import {TYPE_USER} from '../../../../const';
import SelectStaff from '../../../CreateTask/components/SelectStaff';

const ModalCreateTask: FC<IModalCreateTask> = ({flag, onRequestClose, props}) => {
    const {typeModal, user, order} = props;
    const { currentUser } = useStoreon<State, Events>('currentUser');
    const {openModalCall} = useModal();

    const isSuperUser = currentUser.user_status === TYPE_USER.SUPERUSER

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValueCreateTaskCustomer(user || null, typeModal, order, isSuperUser ? null : currentUser),
        validationSchema: isSuperUser ? createTaskSchemaSuperAdmin : createTaskSchemaStaff,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (values) => submitModalCreateTask(values, onRequestClose)
    });

    return (
        <ModalLayout
            flag={flag}
            onClose={onRequestClose}
        >
            <div className={styles['header']}>
                <div className={styles['header--container']}>
                    <GxIcon className={styles['header--icon']} src={TaskIcon}/>
                    <h2 className={styles['header--title']}>Поставить задачу</h2>
                </div>
                {user && <span>Кому: {user.first_name} {user.last_name}</span>}
            </div>
            <GxForm onGx-submit={formik.submitForm}>
                <div className={styles['main']}>
                    <div className={styles['task']}>
                        <div className={styles['task--group']}>
                            <GxInput
                                label='Наименование:'
                                name="title"
                                value={formik.values.title}
                                onGx-change={(e: Record<string, any>) => formik.setFieldValue('title', e.target.value)}
                                className={cn(styles['task--item'], styles['task--item_input'])}
                            />
                            <p className={styles['error']}>{formik.errors.title}</p>
                        </div>
                        {typeModal === TYPE_MODAL_TASK.CALL_INFO &&
                          <>
                        <div className={styles['task--group']}>
                          <span className={styles['task--group_label']}>Тип задачи:</span>
                          <TypeTaskSelect
                            value={formik.values.source}
                            onChangeSelect={(selectedOption) => formik.setFieldValue('source', selectedOption)}
                            classNameBlock={styles['task--item_select']}
                          />
                        </div>
                            <p className={styles['error']}>{formik.errors.source}</p>
                        </>
                        }
                        {currentUser.user_status === TYPE_USER.SUPERUSER &&
                        <div className={styles['task--group']}>
                          <span className={styles['task--group_label']}>Персонал:</span>
                          <SelectStaff
                            value={formik.values.user}
                            classNameBlock={styles['task--item_select']}
                            onChangeSelect={(selectedOption) => {
                                formik.setFieldValue('user', selectedOption);
                                formik.setFieldValue('groups', null);
                            }}
                            params={{
                                user_status: [TYPE_USER.STAFF,currentUser.user_status === TYPE_USER.SUPERUSER && TYPE_USER.SUPERUSER].join()
                            }}
                          />
                          <p className={styles['error']}>{formik.errors.user}</p>
                        </div>
                        }
                        {(currentUser.user_status === TYPE_USER.SUPERUSER || formik.values.flagStaff) &&
                        <div className={styles['task--group']}>
                          <span className={styles['task--group_label']}>Группа:</span>
                          <MultiSelectGroups
                            value={formik.values.groups}
                            classNameBlock={styles['task--item_select']}
                            onChangeSelect={(selectedOption) => {
                                formik.setFieldValue('groups', selectedOption);
                                formik.setFieldValue('user', null);
                            }}
                            flagStaff={formik.values.flagStaff}
                          />
                          <p className={styles['error']}>{formik.errors.groups}</p>
                        </div>
                        }
                        <div className={styles['calendar']}>
                            <span className={styles['calendar--label']}>Срок:</span>
                            <DatePicker
                                weekDays={weekDays}
                                months={months}
                                weekStartDayIndex={1}
                                render={<CalendarInput type='md'/>}
                                format="MM/DD/YYYY HH:mm:ss"
                                plugins={[
                                    <TimePicker position='bottom'/>
                                ]}
                                onChange={(date: any) => formik.setFieldValue('deadline_at', dayjs(date).utc().format())}
                            />
                        </div>
                        {formik.values.is_repeat &&
                        <>
                          <div className={styles['task--group']}>
                            <GxInput
                              name="repeat_count_remain"
                              label='Кол-во повторений:'
                              className={cn(styles['task--item'], styles['task--item_input'], styles['task--item--count'])}
                              onGx-change={(e: Record<string, any>) => formik.setFieldValue('repeat_count_remain', e.target.value)}
                            />
                          </div>
                          <div className={styles['task--group']}>
                            <span className={styles['task--group_label']}>Повторяемость:</span>
                            <Select
                              options={TYPE_REPEAT_TASK}
                              value={formik.values.remind_type}
                              styles={customStylesSelect}
                              name='remind_type'
                              placeholder='Выберите'
                              onChange={(selectedOption) => formik.setFieldValue('remind_type', selectedOption)}
                              className={styles['task--item_select']}
                            />
                          </div>
                          <div
                            className={styles['task--group']}>
                            <span className={styles['task--group_label']}>Дни недели:</span>
                            <Select
                              isMulti
                              options={DAYS_WEEK_TASK}
                              value={formik.values.repeat_dow}
                              styles={customStylesSelect}
                              name='repeat_dow'
                              placeholder='Выберите'
                              onChange={(selectedOption) => {
                                  formik.setFieldValue('repeat_dow', selectedOption);
                              }}
                              className={styles['task--item_select']}
                            />
                          </div>
                          <div
                            className={styles['calendar']}>
                            <span className={styles['calendar--label']}>Время повторений:</span>
                            <DatePicker
                              render={<CalendarInput type='md' time/>}
                              disableDayPicker
                              format="HH:mm:ss"
                              plugins={[
                                  <TimePicker/>
                              ]}
                              onChange={(date: DateObject) => formik.setFieldValue('repeat_time_at', date.format('HH:mm:ss'))}
                            />
                          </div>
                          <div
                            className={styles['task--group']}>
                            <span className={styles['task--group_label']}>Числа:</span>
                            <Select
                              isMulti
                              options={DAYS_TASK}
                              value={formik.values.repeat_day}
                              styles={customStylesSelect}
                              name='repeat_day'
                              placeholder='Выберите'
                              onChange={(selectedOption) => formik.setFieldValue('repeat_day', selectedOption)}
                              className={styles['task--item_select']}
                            />
                          </div>
                          <div className={styles['task--group']}>
                            <span className={styles['task--group_label']}>Месяц:</span>
                            <Select
                              options={MONTH_WEEK_TASK}
                              value={formik.values.repeat_month}
                              styles={customStylesSelect}
                              name='repeat_month'
                              isMulti
                              placeholder='Выберите'
                              onChange={(selectedOption) => formik.setFieldValue('repeat_month', selectedOption)}
                              className={styles['task--item_select']}
                            />
                          </div>
                        </>
                        }
                        <div className={cn(styles['phone'])}>
                            <label htmlFor="phone" className={cn(styles['phone'], styles['phone--label'])}>
                                <span>Телефон:</span>
                                <GxPhoneInput
                                    value={formik.values.phone}
                                    country='ru'
                                    className={styles['phone--input']}
                                    onGx-change={(phone: Record<string, any>) => formik.setFieldValue('phone', `+${phone.detail.value}`)}
                                />
                            </label>
                            <GxButton className={styles['phone--btn']} onClick={() => openModalCall(formik.values.phone)}>
                                <GxIcon src={PhoneIcon} className={styles['phone--icon']}/>
                            </GxButton>
                            <p className={styles['error']}>{formik.errors.phone}</p>
                        </div>
                        <div className={styles['task--group']}>
                            <GxInput
                                name="client_name"
                                label='Имя:'
                                className={cn(styles['task--item'], styles['task--item_input'])}
                                value={formik.values.client_name}
                                onGx-change={(e: Record<string, any>) => formik.setFieldValue('client_name', e.target.value)}
                            />
                        </div>
                        <div className={styles['task--group']}>
                            <GxInput
                                value={formik.values.email}
                                name="email"
                                label='E-mail:'
                                className={cn(styles['task--item'], styles['task--item_input'])}
                                onGx-change={(e: Record<string, any>) => formik.setFieldValue('email', e.target.value)}
                            />
                            <p className={styles['error']}>{formik.errors.email}</p>
                        </div>
                        <div className={styles['task--group']}>
                            <GxTextarea
                                resize='none'
                                label='Описание:'
                                name="description"
                                className={cn(styles['task--item'], styles['task--item_textarea'])}
                                onGx-change={(e: Record<string, any>) => formik.setFieldValue('description', e.target.value)}
                            />
                        </div>
                        <div className={styles['task--group']}>
                            {currentUser.user_status === 'staff' &&
                            <Switcher
                              label={!formik.values.flagStaff ? 'На себя' : 'На группу'}
                              onGx-change={(e: any) => {
                                  formik.setFieldValue('flagStaff', e.target.checked);
                                  if (!e.target.checked) {
                                      formik.setFieldValue('user', {value: currentUser.id});
                                      formik.setFieldValue('groups', []);
                                  } else {
                                      formik.setFieldValue('user', null);
                                  }
                              }}
                              checked={formik.values.flagStaff}
                              className={styles['switcher']}
                            />
                            }
                            <GxCheckbox
                                className={styles['type']}
                                onGx-change={(e: Record<string, any>) => formik.setFieldValue('is_urgent', e.target.checked)}>
                                Срочная задача:
                            </GxCheckbox>
                        </div>
                    </div>
                </div>
                <div className={styles['actions']}>
                    <div className={styles['actions--container']}>
                        <div className={styles['subheader']}>
                            <span className={styles['subheader--subtitle']}>Прикрепить файл</span>
                        </div>
                        <div className={styles['actions--container_main']}>
                            <span className={styles['file-upload--title']}>Файл:</span>
                            <InputUploadFile name='attach' setFieldValue={formik.setFieldValue}/>
                        </div>
                    </div>
                    {typeModal === TYPE_MODAL_TASK.USER &&
                    <div className={styles['actions--container']}>
                      <div className={styles['subheader']}>
                        <span className={styles['subheader--subtitle']}>Статус задачи</span>
                      </div>
                      <div className={styles['actions--container_main']}>
                        <GxRadio
                          name="is_repeat"
                          checked={!formik.values.is_repeat}
                          className={styles['actions--item']}
                          onGx-change={() => formik.setFieldValue('is_repeat', false)}
                        >
                          Один раз
                        </GxRadio>
                        <GxRadio
                          name="is_repeat"
                          checked={formik.values.is_repeat}
                          className={styles['actions--item']}
                          onGx-change={() => {
                              formik.setFieldValue('is_repeat', true);
                              formik.setFieldValue('source', []);
                          }
                          }
                        >
                          Регулярно
                        </GxRadio>
                      </div>
                    </div>
                    }
                </div>
                <div className={styles['footer']}>
                    <GxButton className={styles['footer--btn']} onClick={onRequestClose}>Отмена</GxButton>
                    <GxButton className={styles['footer--btn']} type='submit'>Сохранить</GxButton>
                </div>
            </GxForm>
        </ModalLayout>
    );
};

export default ModalCreateTask;
